import React, { createContext, useContext } from 'react';
import { useCountryDetection } from '../hooks/useCountryDetection';
import CountryModal from '../components/CountryModal';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const {
    detectedCountry,
    showModal,
    isLoading,
    handleSelectCountry,
    clearCountry
  } = useCountryDetection();

  return (
    <CountryContext.Provider
      value={{
        detectedCountry,
        isLoading,
        clearCountry
      }}
    >
      {children}
      <CountryModal
        open={showModal}
        onSelectCountry={handleSelectCountry}
      />
    </CountryContext.Provider>
  );
};
